let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("113SW"), load("17Qwb"), load("aqrmm")]).then(() => parcelRequire('eGpGX'));